import classNames from 'classnames/bind';
import styles from './DeleteAccount.module.scss';
import { AppBar, Box, InputLabel, TextField, Typography } from '@mui/material';
import { images } from '~/assets';
import { Button } from '@mui/material';
import { ILoginPayload } from '~/utils/interface/auth';
import { handleDeleteAccount } from '~/thunks/auth/authThunk';
import { useAppDispatch } from '~/redux/hooks';
import { handleApiError, notify } from '~/utils/helper';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';

const cx = classNames.bind(styles);

const initialValues: ILoginPayload = {
  email: '',
  password: '',
};

const DeleteAccount = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation(['admin/job', 'admin/common']);
  const form = useFormik({
    initialValues,
    onSubmit: async (values, { setFieldError }) => {
      try {
        await dispatch(handleDeleteAccount(values)).unwrap();
        notify('success', t('deleteSuccessMessage', { ns: 'admin/common' }));
      } catch (e) {
        handleApiError(e, setFieldError);
      }
    },
  });

  // const navigate = useNavigate();

  // const redirectSignUp = () => {
  //   navigate(`${adminRouteAbsolute.signUp}`);
  // };

  // const redirectLogin = () => {
  //   navigate(`${adminRouteAbsolute.login}`);
  // };

  // const redirectForgotPassword = () => {
  //   navigate(`${adminRouteAbsolute.forgotPassword}`);
  // };
  return (
    <Box className={cx('w-full', 'h-full')}>
      <AppBar
        color='inherit'
        className={cx('px-4 md:px-20 py-2.5 border-b border-[#E5EAEF]')}
        elevation={0}
        position='relative'
      >
        <Box className={cx('flex justify-between items-center')}>
          <img src={images.logo} alt='' className={cx('w-[61px] h-[62px]')} />
          <Box className={cx('h-9')}>
            {/* <Button
              className={cx(
                'h-9 w-16 inline-block !font-medium !rounded-lg !leading-[16.8px] !text-[#3A3F51] !mr-3 !px-[14px] !py-[7px]'
              )}
              onClick={redirectLogin}
            >
              Login
            </Button> */}
            {/* <Button
              variant='contained'
              color='primary'
              className={cx('!rounded-lg !leading-[16.8px] h-9 w-[76px] !px-[14px] !py-[7px]')}
              onClick={redirectSignUp}
            >
              Sign up
            </Button> */}
          </Box>
        </Box>
      </AppBar>
      <Box className={cx('w-full sm:h-[calc(100%-83px)] relative z-10')}>
        <Box component='section' className={cx('w-full h-full flex justify-center items-center')}>
          <Box component='form' onSubmit={form.handleSubmit} className={cx('max-w-[500px] w-full px-4 sm:px-0')}>
            <Box>
              <Box className={cx('text-center gap-5')}>
                <img src={images.logo} alt='' className={cx('w-[60px] h-[60px] inline-block')} />
                <Box className={cx('mt-5')}>
                  <Typography
                    variant='body1'
                    className={cx('!font-normal text-[16px] !leading-[19.2px] !text-[#86929D] !mt-2.5')}
                  >
                    Delete your account
                  </Typography>
                </Box>
              </Box>
              <Box className={cx('sm:mt-[60px] mt-6')}>
                <Box>
                  <InputLabel className={cx('!text-[12px] text-[#323953] !font-normal !leading-[14.4px]')}>
                    Email
                  </InputLabel>
                  <TextField
                    className='w-full'
                    name='email'
                    placeholder='Enter your email'
                    value={form.values.email}
                    onChange={form.handleChange}
                    error={Boolean(form.errors.email)}
                    helperText={form.errors.email}
                  />
                </Box>
                <Box className='mt-5'>
                  <InputLabel className={cx('!text-[12px] text-[#323953] !font-normal !leading-[14.4px]')}>
                    Password
                  </InputLabel>
                  <TextField
                    className='w-full'
                    name='password'
                    type='password'
                    placeholder='Password'
                    value={form.values.password}
                    onChange={form.handleChange}
                    error={Boolean(form.errors.password)}
                    helperText={form.errors.password}
                  />
                </Box>
              </Box>
            </Box>
            <Box className={cx('mt-[30px]')}>
              <Button
                type='submit'
                variant='contained'
                sx={{
                  backgroundColor: 'red',
                  boxShadow: 'none',
                  '&:hover': {
                    backgroundColor: 'darkred', // Darken the red on hover
                    boxShadow: 'none',
                  },
                }}
                className={'w-full !rounded-lg h-9 !leading-[16.8px]'}
              >
                Delete Account
              </Button>

              {/* <Box className={cx('h-5 mt-3 flex items-center justify-center')}> */}
              {/* <FormControlLabel control={<Checkbox className='text-[16px]' />} label='Remember me' value='true' /> */}

              {/* <Link
                  href='#'
                  underline='none'
                  className='!font-medium w-[121px] text-[14px] !leading-[19.2px]'
                  onClick={redirectForgotPassword}
                >
                  Forgot password
                </Link>
              </Box> */}
              {/* <p className={'text-center text-[16px] mt-5'}>
                <span className={'text-[#86929D] font-normal'}>Don't have an account? </span>
                <Link href='#' underline='none' className={'!font-medium'}>
                  Sign up
                </Link>
              </p> */}
            </Box>
          </Box>
        </Box>
      </Box>
      <Box
        className={cx(
          'w-full',
          'h-[40%]',
          'background-bottom',
          'fixed',
          'bottom-0',
          'bg-cover',
          'bg-center',
          'opacity-[0.02]'
        )}
      ></Box>
    </Box>
  );
};

export default DeleteAccount;
